import SeoTpaGalleryComponent from '@wix/thunderbolt-elements/src/components/SeoTpaGallery/viewer/SeoTpaGallery';


const SeoTpaGallery = {
  component: SeoTpaGalleryComponent
};


export const components = {
  ['SeoTpaGallery']: SeoTpaGallery
};


// temporary export
export const version = "1.0.0"
